import context, { IAppUserContext } from '@truckdown/components-systems';
import { IInitializer, IUserContext } from "@truckdown/systems";

import activityBoard from "./ActivityBoard/ActivityBoard.vue";
import activityBoardMap from "./ActivityBoard/Map/Map.vue";
import activityBoardCallHistory from "./ActivityBoard/CallHistory/CallHistory.vue";
import activityBoardSearchHistory from "./ActivityBoard/SearchHistory/SearchHistory.vue";

import listingList from "./ListingList/ListingList.vue";
import notesList from "./NotesList/NotesList.vue";
import banners from "./BannersComponent/BannersComponent.vue";
import promotionSummary from "./Promotions/PromotionSummary/PromotionSummary.vue";
import searchHistory from "./SearchHistory/SearchHistory.vue";
import callHistory from "./CallHistory/CallHistory.vue";
import note from "./Note/Note.vue";
import statusMessage from "./StatusMessage/StatusMessage.vue";
import dashboard from "./Promotions/Dashboard/Dashboard.vue";
import bannerList from './BannerList/BannerList.vue';
import dynamicMap from './DynamicMap/DynamicMap.vue';
import duplicateAccounts from './DuplicateAccounts/DuplicateAccounts.vue';
import networkLists from './NetworkLists/NetworkLists.vue';
import listingPreferences from './ListingPreferences/ListingPreferences.vue';
import dataSources from './DataSources/DataSources.vue';
import VueGoogleMaps from '@fawmi/vue-google-maps';
class ComponentInitializer implements IInitializer {
    name: string = 'ComponentInitializer';
    order: number = 0;

    initialize(context: IUserContext): Promise<void> {
        console.log('Running Component Initializer from Locations.Client');
        let app = (context as IAppUserContext).app;
         app.use(VueGoogleMaps, {
            load: {
                key: context.settings['maps-key'] ?? '',
                v: 'weekly'
            }
        });
        app.component('dashboard', dashboard);
        app.component('activity-board', activityBoard);
        app.component('activity-board-map', activityBoardMap);
        app.component('activity-board-call-history', activityBoardCallHistory);
        app.component('activity-board-search-history', activityBoardSearchHistory);
        app.component('banners', banners);
        app.component('promotion-summary', promotionSummary);
        app.component('listing-list', listingList);
        app.component('search-history', searchHistory);
        app.component('call-history', callHistory);
        app.component('notes-list', notesList);
        app.component('note', note);
        app.component('status-message', statusMessage);
        app.component('duplicate-accounts', duplicateAccounts);
        app.component('network-lists', networkLists);
        app.component('listing-preferences', listingPreferences);
        app.component('data-sources', dataSources);
        app.component('banner-list', bannerList);
        app.component('dynamic-map', dynamicMap);

        return Promise.resolve();
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new ComponentInitializer();
    }
});
